import React from 'react'
import Card from 'react-bootstrap/Card';
import '../mysass.scss';
import {
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';

const Culture = () => {
  return (

    <>

<div className='anchorsculture' id='culture' style={{textAlign:'center',fontSize:'16px'}}>
      Some cultures of <b>KOSOVO</b>:
    </div>

    {/* <br></br> */}


    <MDBRow className='m-1 row-cols-1 row-cols-md-3 g-4'>

  
      <MDBCol>
            <Card className="bg-dark text-white" style={{height:'550px'}}>
      <Card.Img className='cultureimages' src="ulpiana.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>Ulpiana archeological</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            Ulpiana was an ancient Roman city in what is now Kosovo. Ulpiana, located in the archaeological site of Pristina, is a Roman-Pre-Byzantine settlement that can be considered one of the most important cultural heritage sites in the Republic of Kosova.
            Ulpiana was the administrative, economic and cultural center in Roman times, about eleven kilometers southeast of Pristina, Ulpiana is a Roman-pre-Byzantine settlement.            </MDBCardText>
          </MDBCardBody>
    </Card>
      </MDBCol>

      <MDBCol>
            <Card className="bg-dark text-white" style={{height:'550px'}}>
      <Card.Img className='cultureimages' src="prizrenleague.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>League of Prizren (Lidhja e Prizrenit)</MDBCardTitle>
            <MDBCardText style={{fontSize:'13px'}}>
            Lidhja e Prizrenit was an association of Albanian intellectuals founded in 1878 in today's Kosovar Prizren, with the aim of preventing the division of areas inhabited by Albanians through political and military pressure.            
            One of their first steps was to draw up a memorandum to the Earl of Beaconsfield, the British representative at the Berlin Congress.

In it they formulated: “Just as we are not or do not want to be Turks, we will oppose with all our strength anyone who wants to make us Slavs, Austrians or Greeks. We want to be Albanians ".</MDBCardText>
          </MDBCardBody>
    </Card>
      </MDBCol>

      <MDBCol>
            <Card className="bg-dark text-white" style={{height:'550px'}}>
      <Card.Img className='cultureimages' src="museum1.jpg" alt="Card image" />
      <Card.ImgOverlay style={{textAlign:'center'}}>
      </Card.ImgOverlay>
      <MDBCardBody>
            <MDBCardTitle>National Museum of Kosovo, Prishtinë</MDBCardTitle>
            <MDBCardText style={{fontSize:'14px'}}>
            The Museum of Kosovo is the largest and most important museum in Kosovo. It is located in the city  Pristina and was founded in 1949. The collection contains over 50,000 artifacts.            
            The museum's exhibits and artifacts are exhibited and stored in three buildings. The collection contains over 50,000 artifacts. Another 1,200 objects are to be brought back from Belgrade in the future.</MDBCardText>
          </MDBCardBody>
    </Card>
      </MDBCol>
      </MDBRow>


      {/* ë */}
    </>
  )
}

export default Culture